// extracted by mini-css-extract-plugin
module.exports = {"transactionHashWrapper":"TransactionHashPill_transactionHashWrapper__2OCwj","externalLinkIcon":"TransactionHashPill_externalLinkIcon__g68m_"};